import styled, { keyframes } from 'styled-components';
import LoaderCar from './loader-car.svg';

const wink = keyframes`
    from {
        opacity: 0;
    }
    
    to {
        opacity: 1;
    }
    `;

const CarIcon = styled(LoaderCar)`
  color: var(--colors-primary-blue-4);
  fill: var(--colors-primary-blue-4);
  animation: ${wink} 1.25s ease-in-out infinite alternate;
`;

export default CarIcon;
